import { createFileRoute } from '@tanstack/react-router';
import { SalesOrdersRegister } from '../../../../features/sales-invoicing/SalesOrdersRegister';

/** Sales orders register — closes the audit's #1 functional blocker
 * (services/api/src/modules/sales/sales-orders.ts had a complete backend and
 * zero screens). */
export const Route = createFileRoute('/_authenticated/sales-invoicing/sales-orders/')({
  component: SalesOrdersRegister,
});
